// 講師共有掲示板スレッドのエンティティ
export class TeacherBbs {
  // スレッドID DB型(*autokey)
  public bbs_thread_id?: number;
  // スレッド主ユーザ DB型(*fk)
  public user_id?: string;
  // スレッド日時 DB型(TIMESTAMP)
  public thread_dt?: Date;
  // タイトル DB型(*varchar1024)
  public title?: string;
  // メッセージ DB型(MEDIUMTEXT)
  public message?: string;
  // 親スレッドID DB型(*autokeyFk)
  public parent_thread_id?: number;
  // ベーススレッド DB型(*flg)
  public is_base?: boolean;
  static fromDB(record: { [column: string]: any; [column: number]: any }): TeacherBbs {
    const entity = new TeacherBbs();
    entity.bbs_thread_id = record['bbs_thread_id'];
    entity.user_id = record['user_id'];
    entity.thread_dt = record['thread_dt'];
    entity.title = record['title'];
    entity.message = record['message'];
    entity.parent_thread_id = record['parent_thread_id'];
    entity.is_base = record['is_base'];
    return entity;
  }
  static getTypeFitEntity(value: any): TeacherBbs {
    const entity = new TeacherBbs();
    entity.bbs_thread_id = value.bbs_thread_id;
    entity.user_id = value.user_id;
    entity.thread_dt = value.thread_dt;
    entity.title = value.title;
    entity.message = value.message;
    entity.parent_thread_id = value.parent_thread_id;
    entity.is_base = value.is_base;
    return entity;
  }
}
